import { render, staticRenderFns } from "./backManagement.vue?vue&type=template&id=57b4d5b8&scoped=true&"
import script from "./backManagement.vue?vue&type=script&lang=js&"
export * from "./backManagement.vue?vue&type=script&lang=js&"
import style0 from "./backManagement.vue?vue&type=style&index=0&id=57b4d5b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57b4d5b8",
  null
  
)

export default component.exports